export default __webpack_public_path__ + "static/media/ScannerStationPassthrough.787fdb1e.svg";